import { useEffect, useState } from "react";
import { Composer, ExternalLink, MessageList, Page, Skeleton } from "../components/ui.jsx";
import { readList, appendItem } from "../lib/storage.js";
import { LEADERSHIP, CHECKIN_MOODS } from "../data/leadership.js";

// Leader-only page: a personal check-in, the reading shelf, and the Roundtable.
export default function LeadershipPlus({ back, userName }) {
  const [mood, setMood] = useState(null);
  const [asked, setAsked] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    readList("chat:leadership").then((list) => {
      setItems(list);
      setLoading(false);
    });
  }, []);

  // Routes into the same private inbox the Wall's private notes use.
  const askForCheckIn = async () => {
    await appendItem("leadership-inbox", {
      kind: "checkin",
      name: userName,
      ts: Date.now(),
      text: `${mood.label} — asked for a check-in from LEADERSHiP+.`,
    });
    setAsked(true);
  };

  return (
    <Page
      back={back}
      eyebrow="Build Your Lid"
      title="LEADERSHiP+."
      intro={`Hey ${userName !== "Anonymous" ? userName : "leader"} — before the content, a real question: how are you doing? Not the team. Not Sunday. You.`}
    >
      <div className="chips">
        {CHECKIN_MOODS.map((m) => (
          <button
            key={m.k}
            className={"chip" + (mood && mood.k === m.k ? " on" : "")}
            onClick={() => {
              setMood(m);
              setAsked(false);
            }}
          >
            {m.label}
          </button>
        ))}
      </div>

      {mood && (
        <div className="checkin-reply">
          {mood.reply}
          {mood.offer && !asked && (
            <div style={{ marginTop: 12 }}>
              <button className="btn-post" onClick={askForCheckIn}>
                🤍 Ask a pastor to check on me
              </button>
            </div>
          )}
          {asked && (
            <div style={{ marginTop: 10, fontWeight: 600 }}>
              ✓ Sent. Somebody's going to reach out — you're covered.
            </div>
          )}
        </div>
      )}

      <div className="block" style={{ marginTop: 32 }}>
        <h3>📚 The shelf</h3>
        <p>
          Content that raises your leadership lid. Tap a cover to open the PDF. Everything
          lives in the Leadership Drive — these covers go live as file links are added.
        </p>
      </div>

      <div className="cover-grid">
        {LEADERSHIP.files.map((f) => (
          <ExternalLink
            key={f.title}
            className={"coverc cover-" + f.tone}
            // Covers with no file of their own fall back to the folder id.
            id={f.url === "REPLACE_ME" ? LEADERSHIP.driveFolder : f.url}
          >
            <span className="ce">{f.emoji}</span>
            <span>
              <span className="ct">{f.title}</span>
              <span className="cs" style={{ display: "block" }}>
                PDF · Tap to open
              </span>
            </span>
          </ExternalLink>
        ))}
      </div>

      <ExternalLink id={LEADERSHIP.driveFolder}>
        <div className="name">
          <span>🗂️ Open the full Leadership Drive</span>
          <span className="arrow">→</span>
        </div>
      </ExternalLink>

      <div className="block" style={{ marginTop: 32 }}>
        <h3>💬 The Roundtable</h3>
        <p>
          Questions, takeaways, iron sharpening iron. Leaders only — but public to every
          leader in the hub.
        </p>
      </div>

      <Composer
        placeholder="Ask a question, share a win, work something out loud…"
        onPost={async (text) =>
          setItems(
            await appendItem("chat:leadership", { name: userName, text, ts: Date.now() }),
          )
        }
      />
      {loading ? (
        <Skeleton />
      ) : (
        <MessageList items={items} empty="The table's set. Ask the first question." />
      )}
    </Page>
  );
}
